import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <h1>Use this app to search for Github users</h1>
      <p>Try it out!</p>
      <p>Version: 1.0.0</p>
    </Fragment>
  );
};

export default About;
